// extracted by mini-css-extract-plugin
export default {"browser-web":"MainLayout_browser-web__MQtdu"};